// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Ouroboros_Models_Brands_AdminUserRole from "../Ouroboros.Models.Brands.AdminUserRole/index.js";
import * as Ouroboros_Models_Brands_AdminUserStatus from "../Ouroboros.Models.Brands.AdminUserStatus/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_InviteRejectionReason from "../Ouroboros.Models.Brands.InviteRejectionReason/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_SeatCount from "../Ouroboros.Models.Brands.SeatCount/index.js";
import * as Ouroboros_Models_Brands_UUID from "../Ouroboros.Models.Brands.UUID/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_DateTime from "../Ouroboros.Services.FFI.DateTime/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var updateUser = function (userId) {
    return function (updater) {
        return map(function (user) {
            var $15 = Ouroboros_Models_Brands_UUID.unwrap(user.id) === userId;
            if ($15) {
                return updater(user);
            };
            return user;
        });
    };
};
var initialUsers = /* #__PURE__ */ (function () {
    var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
    return [ {
        id: Ouroboros_Models_Brands_UUID.makeUUID("bastion-user"),
        email: Ouroboros_Models_Brands_Email.makeEmail("bastion@ouroboros.ai"),
        role: Ouroboros_Models_Brands_AdminUserRole.makeAdminUserRole("SuperAdmin"),
        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Active"),
        invitedAt: Data_Maybe.Nothing.value,
        activatedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp)),
        suspendedAt: Data_Maybe.Nothing.value
    }, {
        id: Ouroboros_Models_Brands_UUID.makeUUID("admin-user"),
        email: Ouroboros_Models_Brands_Email.makeEmail("admin@ouroboros.ai"),
        role: Ouroboros_Models_Brands_AdminUserRole.makeAdminUserRole("Admin"),
        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Active"),
        invitedAt: Data_Maybe.Nothing.value,
        activatedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp)),
        suspendedAt: Data_Maybe.Nothing.value
    }, {
        id: Ouroboros_Models_Brands_UUID.makeUUID("pending-user"),
        email: Ouroboros_Models_Brands_Email.makeEmail("pending@ouroboros.ai"),
        role: Ouroboros_Models_Brands_AdminUserRole.makeAdminUserRole("User"),
        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Pending"),
        invitedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp)),
        activatedAt: Data_Maybe.Nothing.value,
        suspendedAt: Data_Maybe.Nothing.value
    } ];
})();
var usersRef = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](initialUsers));
var createStubAdminUserClient = {
    listUsers: /* #__PURE__ */ Ouroboros_Services_FFI_TaskEither.fromIO(function __do() {
        var users = Effect_Ref.read(usersRef)();
        var seatsUsedCount = Data_Array.length(Data_Array.filter(function (user) {
            return Ouroboros_Models_Brands_AdminUserStatus.unwrap(user.status) !== "Suspended";
        })(users));
        return {
            items: users,
            seatsUsed: Ouroboros_Models_Brands_SeatCount.makeSeatCount(Data_Int.toNumber(seatsUsedCount)),
            seatLimit: Ouroboros_Models_Brands_SeatCount.makeSeatCount(Data_Int.toNumber(10))
        };
    }),
    inviteUsers: function (emails) {
        return Ouroboros_Services_FFI_TaskEither.fromIO((function () {
            var normalized = map(Data_String_Common.toLower)(emails);
            var isRejected = Data_String_CodeUnits.contains("reject");
            var rejectedEmails = Data_Array.filter(isRejected)(normalized);
            var accepted = Data_Array.filter(function ($19) {
                return !isRejected($19);
            })(normalized);
            var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
            return function __do() {
                var users = Effect_Ref.read(usersRef)();
                var newUsers = map(function (email) {
                    return {
                        id: Ouroboros_Models_Brands_UUID.makeUUID(Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)),
                        email: Ouroboros_Models_Brands_Email.makeEmail(email),
                        role: Ouroboros_Models_Brands_AdminUserRole.makeAdminUserRole("User"),
                        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Pending"),
                        invitedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp)),
                        activatedAt: Data_Maybe.Nothing.value,
                        suspendedAt: Data_Maybe.Nothing.value
                    };
                })(accepted);
                Effect_Ref.write(append(users)(newUsers))(usersRef)();
                return {
                    accepted: map(Ouroboros_Models_Brands_Email.makeEmail)(accepted),
                    rejected: map(function (email) {
                        return {
                            email: Ouroboros_Models_Brands_Email.makeEmail(email),
                            reason: Ouroboros_Models_Brands_InviteRejectionReason.makeInviteRejectionReason("Domain blocked")
                        };
                    })(rejectedEmails)
                };
            };
        })());
    },
    resendInvite: function (userId) {
        return Ouroboros_Services_FFI_TaskEither.fromIO((function () {
            var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
            return function __do() {
                var users = Effect_Ref.read(usersRef)();
                var updated = updateUser(userId)(function (user) {
                    return {
                        id: user.id,
                        email: user.email,
                        role: user.role,
                        status: user.status,
                        activatedAt: user.activatedAt,
                        suspendedAt: user.suspendedAt,
                        invitedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp))
                    };
                })(users);
                Effect_Ref.write(updated)(usersRef)();
                return Ouroboros_Models_Core_Ok.ok;
            };
        })());
    },
    removePending: function (userId) {
        return Ouroboros_Services_FFI_TaskEither.fromIO(function __do() {
            var users = Effect_Ref.read(usersRef)();
            Effect_Ref.write(Data_Array.filter(function (user) {
                return Ouroboros_Models_Brands_UUID.unwrap(user.id) !== userId;
            })(users))(usersRef)();
            return Ouroboros_Models_Core_Ok.ok;
        });
    },
    suspendUser: function (userId) {
        return Ouroboros_Services_FFI_TaskEither.fromIO((function () {
            var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
            return function __do() {
                var users = Effect_Ref.read(usersRef)();
                var updated = updateUser(userId)(function (user) {
                    return {
                        id: user.id,
                        email: user.email,
                        role: user.role,
                        invitedAt: user.invitedAt,
                        activatedAt: user.activatedAt,
                        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Suspended"),
                        suspendedAt: new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp))
                    };
                })(users);
                Effect_Ref.write(updated)(usersRef)();
                return Ouroboros_Models_Core_Ok.ok;
            };
        })());
    },
    reactivateUser: function (userId) {
        return Ouroboros_Services_FFI_TaskEither.fromIO((function () {
            var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
            return function __do() {
                var users = Effect_Ref.read(usersRef)();
                var updated = updateUser(userId)(function (user) {
                    return {
                        id: user.id,
                        email: user.email,
                        role: user.role,
                        invitedAt: user.invitedAt,
                        status: Ouroboros_Models_Brands_AdminUserStatus.makeAdminUserStatus("Active"),
                        suspendedAt: Data_Maybe.Nothing.value,
                        activatedAt: (function () {
                            if (user.activatedAt instanceof Data_Maybe.Nothing) {
                                return new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp));
                            };
                            if (user.activatedAt instanceof Data_Maybe.Just) {
                                return user.activatedAt;
                            };
                            throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.AdminUsersStub (line 155, column 37 - line 157, column 51): " + [ user.activatedAt.constructor.name ]);
                        })()
                    };
                })(users);
                Effect_Ref.write(updated)(usersRef)();
                return Ouroboros_Models_Core_Ok.ok;
            };
        })());
    },
    deleteUser: function (userId) {
        return Ouroboros_Services_FFI_TaskEither.fromIO(function __do() {
            var users = Effect_Ref.read(usersRef)();
            Effect_Ref.write(Data_Array.filter(function (user) {
                return Ouroboros_Models_Brands_UUID.unwrap(user.id) !== userId;
            })(users))(usersRef)();
            return Ouroboros_Models_Core_Ok.ok;
        });
    },
    changeRole: function (userId) {
        return function (role) {
            return Ouroboros_Services_FFI_TaskEither.fromIO(function __do() {
                var users = Effect_Ref.read(usersRef)();
                var updated = updateUser(userId)(function (user) {
                    return {
                        id: user.id,
                        email: user.email,
                        status: user.status,
                        invitedAt: user.invitedAt,
                        activatedAt: user.activatedAt,
                        suspendedAt: user.suspendedAt,
                        role: role
                    };
                })(users);
                Effect_Ref.write(updated)(usersRef)();
                return Ouroboros_Models_Core_Ok.ok;
            });
        };
    },
    changeEmail: function (userId) {
        return function (email) {
            return Ouroboros_Services_FFI_TaskEither.fromIO((function () {
                var timestamp = Ouroboros_Services_FFI_DateTime.nowIso(Data_Unit.unit);
                return function __do() {
                    var users = Effect_Ref.read(usersRef)();
                    var updated = updateUser(userId)(function (user) {
                        return {
                            id: user.id,
                            role: user.role,
                            status: user.status,
                            activatedAt: user.activatedAt,
                            suspendedAt: user.suspendedAt,
                            email: Ouroboros_Models_Brands_Email.makeEmail(email),
                            invitedAt: (function () {
                                var $18 = Ouroboros_Models_Brands_AdminUserStatus.unwrap(user.status) === "Pending";
                                if ($18) {
                                    return new Data_Maybe.Just(Ouroboros_Models_Brands_IsoTimestamp.makeIsoTimestamp(timestamp));
                                };
                                return user.invitedAt;
                            })()
                        };
                    })(users);
                    Effect_Ref.write(updated)(usersRef)();
                    return Ouroboros_Models_Core_Ok.ok;
                };
            })());
        };
    }
};
export {
    createStubAdminUserClient
};
//# sourceMappingURL=index.js.map
